@for (slide of slides; track slide.id) {
  <div
    class="resource-hero"
    [class.resource-hero--has-mobile-sillhouette]="slide.sillhouette.mobile"
    [style.backgroundImage]="getBackgroundImage(slide)"
  >
    <div class="resource-hero__box" container classes="container--1320">
      <div
        class="resource-hero__sillhouette"
        [class.d-none]="!slide.sillhouette.mobile"
        [class.d-md-block]="!slide.sillhouette.mobile"
        [class.d-lg-none]="!slide.sillhouette.desktop"
        [ngStyle]="getSillhouetteStyles(slide)"
      >
        <picture [data]="getSillhouetteData(slide)"></picture>
      </div>

      <div class="resource-hero__layout">
        <div class="resource-hero__media">
          <div class="resource-hero__frame">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/w8AAgMBgA1p1ZcAAAAASUVORK5CYII="
              [alt]="slide.sillhouetteAlt || ''"
              aria-hidden="true"
            />
          </div>
          <div class="resource-hero__side-strip d-none d-md-block"></div>
          <div class="d-none d-md-block">
            <div class="resource-hero__sign-strip"></div>
          </div>
          <div
            class="disclaimer position-absolute"
            [ngStyle]="getDisclaimerStyles(slide)"
          >
            <span *ngIf="slide.id !== 'hcp-resources'">Actor Portrayal</span>
            <span *ngIf="slide.id === 'hcp-resources'">Paid Sanofi Spokesperson</span>
          </div>
        </div>

        <div class="resource-hero__content">
          @if (slide.isFirstSlide) {
            <h1 class="resource-hero__title" [innerHTML]="slide.title"></h1>
          } @else {
            <h2 class="resource-hero__title" [innerHTML]="slide.title"></h2>
          }

          <p
            class="resource-hero__text"
            [class.resource-hero__text--family-history]="slide.id === 't1d-family-history'"
            [innerHTML]="slide.text"
          ></p>

          @if (slide.cta) {
            <a
              class="resource-hero__button btn btn-secondary d-inline-flex align-items-center gap-2 text-white fw-bold"
              [href]="slide.cta.url"
              (click)="onClick($event, slide.cta.url)"
            >
              <span [innerHTML]="slide.cta.text"></span>
              <svg
                width="19"
                height="16"
                viewBox="0 0 19 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M18.2142 8.80049C18.6048 8.40997 18.6048 7.7768 18.2142 7.38628L11.8503 1.02232C11.4598 0.631792 10.8266 0.631792 10.4361 1.02232C10.0455 1.41284 10.0455 2.04601 10.4361 2.43653L16.0929 8.09338L10.4361 13.7502C10.0455 14.1408 10.0455 14.7739 10.4361 15.1645C10.8266 15.555 11.4598 15.555 11.8503 15.1645L18.2142 8.80049ZM0 9.09338H17.5071V7.09338H0L0 9.09338Z"
                  fill="white"
                />
              </svg>
            </a>
          }
        </div>
      </div>
    </div>
  </div>
}
